__turbopack_context__.v({
  "burger": "index-module__QcT7AW__burger",
  "closeLine": "index-module__QcT7AW__closeLine",
  "closeMenu": "index-module__QcT7AW__closeMenu",
  "line": "index-module__QcT7AW__line",
  "menuContainer": "index-module__QcT7AW__menuContainer",
  "menuNavLink": "index-module__QcT7AW__menuNavLink",
  "overlay": "index-module__QcT7AW__overlay",
  "siteLinks": "index-module__QcT7AW__siteLinks",
});
